import { defineStore } from "pinia";
import http from "@/http";
import { LIST_ARMAZEM, ADD_ARMAZEM, UPDATE_ARMAZEM, DEL_ARMAZEM } from "@/http/url";

export const useArmazemStore = defineStore("ArmazemStore", {
  state: () => {
    return {
      armazenados: [],
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_ARMAZENADOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_ARMAZEM)
          .then((response) => {
            this.armazenados = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_ARMAZENADOS(armazem) {
      return http
        .post(ADD_ARMAZEM, armazem)
        .then((response) => this.armazenados.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_ARMAZENADOS(armazem) {
      return http
        .put(`${UPDATE_ARMAZEM + armazem.id}`, armazem)
        .then((response) => {
          const index = this.armazenados.findIndex((objeto) => objeto.id === response.data.id);
          this.armazenados[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_ARMAZENADOS(id) {
      return http.delete(`${DEL_ARMAZEM + id}`).then(() => (this.armazenados = this.armazenados.filter((arm) => arm.id != id)));
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getArmazenados() {
      return this.armazenados;
    },

    getBySgcq: (state) => {
      return (id) => {
        return state.armazenados.filter((arm) => !id || arm.id == id);
      };
    },

    getArmazemLoad(state) {
      return state.loaded;
    },

    getFilterArmazenados: (state) => {
      return (filtro) => {
        let filtrada = state.armazenados;
        filtrada = filtrada.filter(
          (a) =>
            !filtro ||
            (a.descricao.includes(filtro.descricao) && a.codigo.includes(filtro.codigo) && a.estado.includes(filtro.estado))
        );

        return filtrada;
      };
    },
  },
});
